module.exports = __webpack_public_path__ + "static/media/Portret_illustratie_heel.60ab2b73.png";